import FisicaPNG from '../../../assets/images/flashcards/disciplines/fisica.png';
import MatematicaPNG from '../../../assets/images/flashcards/disciplines/matematica.png';
import BiologiaPNG from '../../../assets/images/flashcards/disciplines/biologia.png';
import PortuguesPNG from '../../../assets/images/flashcards/disciplines/portugues.png';
import QuimicaPNG from '../../../assets/images/flashcards/disciplines/quimica.png';
import HistoriaPNG from '../../../assets/images/flashcards/disciplines/historia.png';
import GeografiaPNG from '../../../assets/images/flashcards/disciplines/geografia.png';
import LiteraturaPNG from '../../../assets/images/flashcards/disciplines/literatura.png';
import SociologiaPNG from '../../../assets/images/flashcards/disciplines/sociologia.png';
import FilosofiaPNG from '../../../assets/images/flashcards/disciplines/filosofia.png';
import InglesPNG from '../../../assets/images/flashcards/disciplines/ingles.png';
import EspanholPNG from '../../../assets/images/flashcards/disciplines/espanhol.png';
import RedacaoPNG from '../../../assets/images/flashcards/disciplines/redacao.png';
import AtualidadesPNG from '../../../assets/images/flashcards/disciplines/atualidades.png';
import InterdisciplinarPNG from '../../../assets/images/flashcards/disciplines/interdisciplinar.png';

export const DISCIPLINES_MAP = {
  fisica: {
    title: 'Física',
    bgImage: FisicaPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #D4EFB8 0%, #00B8AB 100%)',
  },
  matematica: {
    title: 'Matemática',
    bgImage: MatematicaPNG,
    gradient:
      'radial-gradient(92.86% 92.86% at 13.79% -21.9%, #8F78DA 0%, #6B59A6 100%)',
  },
  biologia: {
    title: 'Biologia',
    bgImage: BiologiaPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #4B72F3 0%, #1A3BA6 100%)',
  },
  quimica: {
    title: 'Química',
    bgImage: QuimicaPNG,
    gradient:
      ' radial-gradient(80% 55.46% at 15.42% 2.3%, #FF3597 0%, #C41C6E 100%)',
  },
  portugues: {
    title: 'Português',
    bgImage: PortuguesPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #FF9940 0%, #FF6B40 100%)',
  },
  literatura: {
    title: 'Literatura',
    bgImage: LiteraturaPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #F7A480 0%, #F78099 100%)',
  },
  geografia: {
    title: 'Geografia',
    bgImage: GeografiaPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #57F8AD 0%, #05CC70 100%)',
  },
  historia: {
    title: 'História',
    bgImage: HistoriaPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #DCA859 0%, #AB664F 100%)',
  },
  ingles: {
    title: 'Inglês',
    bgImage: InglesPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #00C4E6 0%, #6E8FF2 100%) ',
  },
  espanhol: {
    title: 'Espanhol',
    bgImage: EspanholPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #FEF058 0%, #BFAB2E 100%)',
  },
  sociologia: {
    title: 'Sociologia',
    bgImage: SociologiaPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #FE5900 0%, #C9171A 100%)',
  },
  filosofia: {
    title: 'Filosofia',
    bgImage: FilosofiaPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #F4DA14 0%, #D3AA0E 100%)',
  },
  redacao: {
    title: 'Redação',
    bgImage: RedacaoPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #6CC6FA 0%, #4594C2 100%)',
  },
  atualidades: {
    title: 'Atualidades',
    bgImage: AtualidadesPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #88FFEB 0%, #69BFA0 100%)',
  },
  interdisciplinar: {
    title: 'Interdisciplinar',
    bgImage: InterdisciplinarPNG,
    gradient:
      'radial-gradient(80% 55.46% at 15.42% 2.3%, #63FBF1 0%, #00C4E6 100%)',
  },
};

export const DISCIPLINES_ICONS = [
  FisicaPNG,
  MatematicaPNG,
  BiologiaPNG,
  PortuguesPNG,
  QuimicaPNG,
  HistoriaPNG,
  GeografiaPNG,
  LiteraturaPNG,
  SociologiaPNG,
  FilosofiaPNG,
  InglesPNG,
  EspanholPNG,
  RedacaoPNG,
  AtualidadesPNG,
  InterdisciplinarPNG,
]